import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

/** Filter dropdown: same three states as Ext `ToolUserDetailGrid` Documents column renderer. */
export const toolUserDetailDocumentsFilterDictionary = createSimpleDictionary([
    { id: 'approved', name: 'toolUserDetails.filters.documentsApproved' },
    { id: 'approve', name: 'toolUserDetails.filters.documentsPleaseCheck' },
    { id: 'waiting', name: 'toolUserDetails.filters.documentsWaiting' },
]);
